import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=10d6a459&"
import script from "./overview.vue?vue&type=script&lang=js&"
export * from "./overview.vue?vue&type=script&lang=js&"
import style0 from "./overview.vue?vue&type=style&index=0&id=10d6a459&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports